import home from './home.vue'
export default home



// WEBPACK FOOTER //
// ./src/layout/home/index.js